import * as React from "react";
const SvgFiRrRabbitFast = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-rabbit-fast_svg__a)">
      <path
        fill="#062147"
        d="M19.949 11.816C22.17 11.379 24 10.153 24 8c0-2.402-2.254-5.872-5.804-5.996C17.233 1.642 12.564 0 7 0a1 1 0 1 0 0 2c2.934 0 5.641.502 7.589.994q-.187.093-.376.19C12.534 4.036 10.631 5 7 5a1 1 0 1 0 0 2c2.733 0 4.631-.498 6.122-1.099Q13.001 6.433 13 7c0 .711.149 1.387.418 2H7.736a6.9 6.9 0 0 0-3.898 1.211 2 2 0 1 0-2.3 2.735 6.1 6.1 0 0 0-.508 1.919 6.53 6.53 0 0 0 1.659 5.006A6.51 6.51 0 0 0 7.5 22c.635 0 1.218.292 1.601.801A3 3 0 0 0 11.494 24h7.507a1 1 0 1 0 0-2h-3.215l4.14-10.121q.013-.031.023-.063M22 8c0 1.468-2.392 2-4 2-1.654 0-3-1.346-3-3s1.346-3 3-3c2.481 0 4 2.59 4 4M10.7 21.6A4.02 4.02 0 0 0 7.5 20a4.51 4.51 0 0 1-3.331-1.474 4.47 4.47 0 0 1-1.147-3.472c.216-2.273 2.288-4.055 4.715-4.055h7.267c.765.575 1.7.935 2.715.992l-3.718 9.088v-.08c0-3.813-2.187-6-6-6a1 1 0 1 0 0 2c2.729 0 4 1.271 4 4v1h-.507a.99.99 0 0 1-.793-.4z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-rabbit-fast_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRabbitFast;
